import type { BoxProps } from '../../components/Core/Box';
import { Stack } from '../../components/Core/Stack';
import { Divider } from '../../components/Divider';
import { Text } from '../../components/Text';

/**
 * Divider spreading across the width of the drawer
 */
export const DrawerDivider = () => <Divider mx="-spacing12" color="colors.gray.000" />;

/**
 * SectionVStack is a vertical stack of content with a header and a divider
 */
export const SectionVStack = ({
  header,
  children,
  ...stackProps
}: { header: string; children: React.ReactNode } & BoxProps) => (
  <Stack gap="spacing16" {...stackProps}>
    <Text color="colors.gray.100">{header}</Text>
    {children}
  </Stack>
);
